import React from 'react';
import cn from 'classnames';

import searchClient from 'bl/client/searchClient.bl';
import { withTranslation } from 'providers/GILT.provider';
import { withTheme } from 'providers/Theme.provider';

import CN from './CheckoutTitle.module.scss';

export class CheckoutTitle extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      searchTerm: '',
      currentlyDisplayed: [],
      selectedClient: null,
      clearBtn: false,
      showSearch: false,
      showSearchBtn: true,
    };
  }

  search = (event) => {
    const searchTerm = event.target.value;
    const resultList = searchClient({ text: searchTerm, list: this.props.clients }).sort((b, a) => a.rank - parseFloat(b.rank));
    this.setState({ searchTerm, selectedClient: null, currentlyDisplayed: resultList, clearBtn: true });
  };
  select = (client) => {
    this.setState({
      searchTerm: client.user_name,
      currentlyDisplayed: [],
      selectedClient: client,
    });
  };
  add = () => {
    if (this.state.selectedClient) {
      this.props.onAddHandler(this.state.selectedClient);
      this.setState({
        searchTerm: '',
        selectedClient: null,
        showSearch: false,
        showSearchBtn: true,
      });
    }
  };

  clearClient = () => void this.setState({ searchTerm: '' });
  showInputSearch = () => void this.setState({ showSearch: true, showSearchBtn: false });

  render() {
    const { isDarkMode, t } = this.props;

    return (
      <div
        className={cn({
          [CN.component]: true,
          [CN.dark]: isDarkMode,
        })}
      >
        <div className={`checkout-add-booking ${this.props.mobileClass}`}>
          <div className="toolbar-row empty-client">
            <div className="name">{t('checkout.checkoutTitle.title')}</div>
            <div className="next-appointment" />
          </div>
          <div className="search-client cfix">
            {this.state.showSearchBtn && (
              <div className="add-client-button" role="button" tabIndex={0} onClick={this.showInputSearch}>
                {this.props.btnText}
              </div>
            )}
            {this.state.showSearch && (
              <div className="add-client">
                <input
                  type="text"
                  id="client-search"
                  className={this.state.searchTerm.length > 0 ? 'input-checkout search white-bgr' : 'input-checkout search'}
                  placeholder={t('checkout.checkoutTitle.searchPlaceholder')}
                  value={this.state.searchTerm}
                  onChange={this.search}
                  onBlur={this.add()}
                  autoComplete="off"
                  autoFocus
                />
                {this.state.clearBtn && this.state.searchTerm.length > 0 && <span onClick={this.clearClient} role="button" tabIndex={0} className="btn-clear-search" />}
                <div className="dropdown-container">
                  {!this.state.selectedClient && this.state.currentlyDisplayed.length === 0 && this.state.searchTerm.length > 0 && (
                    <div className="dropdown-suggestions">
                      <div className="empty">{t('common.messages.noResults')}</div>
                    </div>
                  )}
                  {this.state.currentlyDisplayed.length > 0 && this.state.searchTerm.length > 0 && (
                    <div className={CN.dropdown}>
                      {this.state.currentlyDisplayed.map((client) => (
                        <div id="chk-results-item" className={CN.item} key={client.id} onClick={() => this.select(client)} role="menuitem" tabIndex="0">
                          {client.user_name}
                          {client.has_appointment_today && <div>{t('checkout.checkoutTitle.bookingToday')}</div>}
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }
}

const CheckoutTitleHoc = withTranslation()(withTheme()(CheckoutTitle));

export default CheckoutTitleHoc;
